import { getPagePath } from '@spotahome/soyuz/client';

const getCityUrl = (city, suffix) => {
  const url = getPagePath('marketplace.search.deprecated', {
    params: { city }
  });
  return suffix ? decodeURIComponent(`${url}/${suffix}`) : url;
};

export default getCityUrl;
